var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIonSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ion:send"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.2018 11.5302L24.1937 11.5266L2.50605 2.53125C2.32364 2.4549 2.12514 2.42495 1.92832 2.4441C1.7315 2.46324 1.54249 2.53087 1.3782 2.64094C1.20463 2.75467 1.06206 2.90977 0.963308 3.09229C0.86456 3.2748 0.812736 3.479 0.8125 3.68652V9.43953C0.812597 9.72322 0.911655 9.99799 1.0926 10.2165C1.27355 10.435 1.52505 10.5835 1.80375 10.6364L13.6322 12.8236C13.6787 12.8324 13.7207 12.8572 13.7508 12.8936C13.781 12.93 13.7975 12.9759 13.7975 13.0232C13.7975 13.0705 13.781 13.1163 13.7508 13.1527C13.7207 13.1892 13.6787 13.2139 13.6322 13.2227L1.80426 15.4099C1.52563 15.4627 1.27415 15.611 1.09312 15.8293C0.912093 16.0476 0.812855 16.3222 0.8125 16.6058V22.3598C0.812365 22.558 0.86143 22.753 0.955291 22.9276C1.04915 23.1021 1.18487 23.2506 1.35027 23.3597C1.54923 23.4919 1.78273 23.5625 2.0216 23.5628C2.18767 23.5627 2.35203 23.5293 2.50504 23.4648L24.1922 14.5207L24.2018 14.5161C24.4938 14.3907 24.7425 14.1824 24.9173 13.917C25.0921 13.6517 25.1852 13.3409 25.1852 13.0232C25.1852 12.7054 25.0921 12.3946 24.9173 12.1293C24.7425 11.8639 24.4938 11.6557 24.2018 11.5302Z",
    fill: "#202E5F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonSend);
export default __webpack_public_path__ + "static/media/ion_send.924a96f531c313fe3df93e15d16560c7.svg";
export { ForwardRef as ReactComponent };